export const meta = {
  default: {
    url: "/",
    title: "Hiveon Pool – Most profitable and efficient mining pool",
    meta: [
      { name: 'description', content: 'Receive guaranteed high-profit payouts with our PPS+ distribution mode' },
      { name: 'keywords', content: 'hiveon, mining, pool, ethereum, cryptocurrency' },
      { name: 'apple-mobile-web-app-title', content: 'Hiveon' },
      { name: 'application-name', content: 'Hiveon' },
      { name: 'msapplication-TileColor', content: '#1f2228' },
      { name: 'theme-color', content: '#1f2228' },
      { property: 'og:title', content: 'Hiveon Pool – Most profitable and efficient mining pool'},
      { property: 'og:description', content: 'Receive guaranteed high-profit payouts with our PPS+ distribution mode'},
      { property: 'og:image', content: 'https://lbd.hiveos.farm/hiveon-site/static/pool.png' },
      { property: 'twitter:card', content: 'summary_large_image'},
      { property: 'twitter:site', content: '@hiveon' },
      { property: 'twitter:image', content: 'https://lbd.hiveos.farm/hiveon-site/static/pool.png' }
    ]
  },
  etc: {
    url: "/ethereum-classic",
    title: "Hiveon Pool – Most profitable and efficient mining pool",
    meta: [
      { name: 'description', content: 'Receive guaranteed high-profit payouts with our PPS+ distribution mode' },
      { name: 'keywords', content: 'hiveon, mining, pool, ethereum, cryptocurrency' },
      { name: 'apple-mobile-web-app-title', content: 'Hiveon' },
      { name: 'application-name', content: 'Hiveon' },
      { name: 'msapplication-TileColor', content: '#1f2228' },
      { name: 'theme-color', content: '#1f2228' },
      { property: 'og:title', content: 'Hiveon Pool – Most profitable and efficient mining pool'},
      { property: 'og:description', content: 'Receive guaranteed high-profit payouts with our PPS+ distribution mode'},
      { property: 'og:image', content: 'https://lbd.hiveos.farm/hiveon-site/static/pool.png' },
      { property: 'twitter:card', content: 'summary_large_image'},
      { property: 'twitter:site', content: '@hiveon' },
      { property: 'twitter:image', content: 'https://lbd.hiveos.farm/hiveon-site/static/pool.png' }
    ]
  }
}